import { Button, Flex } from "@chakra-ui/react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SignupError } from "../../../common/redux/thunks/auth/signup-as-person-thunk";
import { ConsentCheckboxes, ConsentFieldValues } from "../shared/ConsentCheckboxes";
import { OrgInfoFields, OrgInfoFieldValues } from "../shared/OrgInfoFields";
import { OwnerIdentityFields, OwnerIdentityFieldValues } from "../shared/OwnerIdentityFields";
import { useSignupError } from "../shared/useSignupError";

export type SignupAsOrgFormValues = OrgInfoFieldValues & OwnerIdentityFieldValues & ConsentFieldValues;

interface Props {
  isSubmitting: boolean;
  signupError?: SignupError | string | null;
  onSubmit: (values: SignupAsOrgFormValues) => Promise<void> | void;
}

export const SignupAsOrgForm = ({ isSubmitting, signupError, onSubmit }: Props) => {
  const { t } = useTranslation();
  const methods = useForm<SignupAsOrgFormValues>();

  useSignupError(signupError, methods);

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <OwnerIdentityFields />
        <OrgInfoFields />
        <ConsentCheckboxes />
        <Flex mt="10px" justifyContent="start">
          <Button type="submit" colorScheme="teal" isLoading={isSubmitting}>
            {t("Proceed")}
          </Button>
        </Flex>
      </form>
    </FormProvider>
  );
};
